// Input Box Placeholder
function fnremove(arg,val)	{
	if (arg.value == '') {arg.value = val}
}	
function fnshow(arg,val)	{
	if (arg.value == val) {arg.value = ''}
}

$(document).ready(function () {		
	
	jsUpdateSize(); 	
	$( ".mmoverly" ).appendTo( $( "body" ) );
 
});

// responsive filter table 
$(window).resize(function(){	
	jsUpdateSize();	
});
function jsUpdateSize()
{
	var width = $(window).width();
    var height = $(window).height();	
	if(width<=767)
	{
		$("#filterOptions").addClass("filter-opp");
		$("#filterOptions.filter-opp").hide();		
	}
	else{
		$("#filterOptions").removeClass("filter-opp");
		$("#filterOptions").show();
	}
	if(width<=1023 && width>=768)
	{
		//if(height<=600 && width>=768)
		
	$(".area-container").css("min-height",height);
	}
	else{
	$(".area-container").css("min-height","");	
	}
}

$("#filter-name, .select-arw").click(function()
	{				
	$("#filterOptions.filter-opp").slideToggle();
	});
	
	$("#filterOptions li a").click(function()
	{
		$("#filter-name a.select-txt").html($(this).html());
		$("#filterOptions.filter-opp").slideUp();
});







